import {RFPercentage, RFValue} from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';
import {Dimensions, Image, Platform} from 'react-native';
import {OverlayModal} from '../OverlayModal';
import Feather from 'react-native-vector-icons/Feather';

import FastImage from 'react-native-fast-image';

import {
  getStatusBarHeight,
  isIphoneX,
} from 'react-native-iphone-screen-helper';

const isWeb = Platform.OS === 'web';
const windowHeight = Dimensions.get('window').height;

//@ts-ignore
export const Container = styled(OverlayModal)`
  justify-content: flex-end;
  margin: 0;
`;

export const CloseButton = styled.TouchableOpacity`
  position: absolute;
  top: ${isIphoneX() ? getStatusBarHeight() : RFValue(20)}px;
  right: 24px;
`;
export const CloseButtonIcon = styled(Feather)`
  color: ${({theme}) => theme.colors.shape};
  font-size: ${RFValue(18)}px;
`;

export const ModalContent = styled.View`
  background-color: ${({theme}) => theme.colors.background};

  ${isWeb
    ? `max-height: ${Math.round(windowHeight * 0.9)}px;`
    : `height: ${RFPercentage(62)}px;`}
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  overflow: hidden;
`;

export const ContainerIcons = styled.View`
  flex-direction: row;
  align-items: center;
`;

export const ContainerStationHeader = styled.View`

`;


export const BannerContainer = styled.View`

`;

export const BannerButton = styled.TouchableOpacity`
  margin-bottom: ${RFValue(12)}px;
`;

// FastImage renderiza via componente nativo e fica em branco no webview,
// então na web usamos o Image padrão do react-native.
//@ts-ignore
export const Banner = styled(isWeb ? Image : FastImage)`
  width: 100%;
  height: ${RFValue(70)}px;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;


`;

export const ModalBody = styled.View`
  ${isWeb ? '' : 'flex: 1;'}
  padding: 0 24px;


  margin-bottom: ${RFValue(16)}px;
`;

export const StationInfos = styled.View`
  flex-direction: row;

  align-items: center;
  justify-content: space-between;
`;

export const StationNameModal = styled.View`
  flex: 1;
  margin-right: ${RFValue(12)}px;
`;
export const Title = styled.Text`
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(14)}px;

  font-family: ${({theme}) => theme.fonts.bold};
`;
export const Description = styled.Text`
  color: ${({theme}) => theme.colors.text};
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.regular};
`;

export const Paragraph = styled.Text`
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(12)}px;
  margin-top:${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.regular};
`;

export const Bolder = styled.Text`
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(12)}px;
  margin-top:${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.bold};
`;

export const Bold = styled.Text`
font-family: ${({theme}) => theme.fonts.bold};
`;

export const ButtonContainer = styled.View`
  flex-direction: row;
  width: 100%;
  align-items: center;
  justify-content: space-between;
`;
export const ButtonBack = styled.TouchableOpacity`
  height: ${RFValue(45)}px;
  width: 25%;
  justify-content: center;
  align-items: center;
  margin-right: ${RFValue(12)}px;
  padding-left: 4px;
  border-radius: ${RFValue(12)}px;
`;
export const ButtonBackText = styled.Text`
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
`;

export const ButtonConfirm = styled.TouchableOpacity`
  background-color: ${({theme}) => theme.colors.primary};
  height: ${RFValue(35)}px;
  flex: 1;
  justify-content: center;
  align-items: center;
  border-radius: ${RFValue(26)}px;
`;
export const ButtonConfirmText = styled.Text`
  color: ${({theme}) => theme.colors.shape};
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
`;

export const ModalFooter = styled.View`
  padding: 0 24px;
  padding-bottom: ${RFValue(16)}px;
`;
